import React from 'react'
import type { CenterTab } from '@contexts/TabNavigationContext'

const TAB_NAMES = ['Analysis Report', 'Strategy Workspace']

export const parseTabLinks = (
  text: string,
  onTabClick: (tabName: string) => void
): React.ReactNode[] => {
  // Create regex that matches tab names (case-insensitive)
  const tabPattern = new RegExp(`(${TAB_NAMES.join('|')})`, 'gi')

  const parts = text.split(tabPattern)

  return parts.map((part, index) => {
    const matchedTab = TAB_NAMES.find(
      name => name.toLowerCase() === part.toLowerCase()
    )

    if (matchedTab) {
      return (
        <span
          key={index}
          className="tab-link"
          onClick={(e) => {
            e.stopPropagation()
            onTabClick(matchedTab)
          }}
          role="button"
          tabIndex={0}
          onKeyDown={(e) => {
            if (e.key === 'Enter' || e.key === ' ') {
              e.preventDefault()
              onTabClick(matchedTab)
            }
          }}
        >
          {part}
        </span>
      )
    }

    return <React.Fragment key={index}>{part}</React.Fragment>
  })
}

// Map display names to internal tab IDs
export const getTabId = (tabName: string): CenterTab | null => {
  const mapping: Record<string, CenterTab> = {
    'Strategy Workspace': 'workspace',
    'Analysis Report': 'report',
  }

  return mapping[tabName] || null
}
